class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll("input#Search-In-Modal");
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener("focus", this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener("reset", this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener("input", this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync("", this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: "smooth" });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define("main-search", MainSearch);

class SearchTabs extends HTMLElement {
  constructor() {
    super();
    this.searchTabs = document.querySelectorAll(".js-search-tab");
    this.searchTabs.forEach((tab) => {
      tab.addEventListener("click", this.onTabClick.bind(this, tab));
    });
  }
  onTabClick(tab) {
    const searchType = tab.dataset.type;
    const parsedUrl = new URL(window.location.href);
    // remove all search params except 'q' and 'type'
    for (const key of [...parsedUrl.searchParams.keys()]) {
      if (key !== "q") {
        parsedUrl.searchParams.delete(key);
      }
    }

    // if key == 'q' and it has format like this: ?q=care-guides%20wool or ?q=care-guides + wool remove all before last space or plus sign
    // Here we are reseting article filtering
    if (parsedUrl.searchParams.has("q")) {
      const query = parsedUrl.searchParams.get("q");
      const lastSpaceIndex = query.lastIndexOf(" ");
      const lastPlusIndex = query.lastIndexOf("+");
      const lastIndex = Math.max(lastSpaceIndex, lastPlusIndex);
      if (lastIndex !== -1) {
        parsedUrl.searchParams.set("q", query.substring(lastIndex + 1));
      }
    }

    parsedUrl.searchParams.set("type", searchType);
    window.location.href = parsedUrl;
  }
}

customElements.define("search-tabs", SearchTabs);
